import { render, staticRenderFns } from "./ListTableRentsPremium.vue?vue&type=template&id=1670cdea&"
import script from "./ListTableRentsPremium.vue?vue&type=script&lang=js&"
export * from "./ListTableRentsPremium.vue?vue&type=script&lang=js&"
import style0 from "./ListTableRentsPremium.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ListTableRentsPremium.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VChip } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VCardText,
  VChip,
  VDataTable,
  VDivider,
  VIcon,
  VSpacer,
  VToolbar,
  VToolbarTitle,
})
